import defaultImg from "../../../../assets/svg/jalebi.svg";
import classes from "./Dish.module.scss";

const Dish = ({ name, price, stock, hasImage, img, onClicked }) => {
  let smallName = name.substring(0, 20).trim();
  let continueName = null;

  if (name.length > 20) {
    continueName = "...";
  }

  return (
    <div className={classes.Dish} onClick={onClicked}>
      {hasImage && <img src={img} alt={name} className={classes.DishImage} />}
      {!hasImage && (
        <img src={defaultImg} alt={name} className={classes.DishImage} />
      )}
      <p className={classes.DishName}>
        {smallName}
        {continueName}
      </p>
      <p className={classes.DishPrice}>{price}</p>
      {/* <p className={classes.DishStock}>{stock} remaining</p> */}
    </div>
  );
};

export default Dish;
